// Centralised Framer Motion variants - reused across pages/sections so the
// linter doesn't see "inline object" props on every render, and tweaking
// motion timings happens in one place.

export const FADE_UP = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
};

export const FADE_UP_SOFT = {
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] },
};

export const STEP_TRANSITION = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
  transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] },
};

export const TAP_DOWN = { scale: 0.97 };

// Re-usable easing curve.
export const PREMIUM_EASE = [0.16, 1, 0.3, 1];
